<ng-container *ngIf="modalmode && !viewmode && !smalltype">
  <p>{{ 'tagaddremove.header' | trans }}</p>
  <div class="row mb-2 pl-1">
    <div class="col- mb-2" *ngFor="let ctag of entitytagList; trackBy: trackByEntityTagId">
    <button id="{{ctag.title}}" class="btn rounded pt-1 ml-2 pl-2 pr-2 pb-1" style="margin-top:-2px;">
      <p class="btn-text mb-0 ">{{ctag.title}}           
        <span (click)="removeTag(ctag)"
        class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
        close
      </span>
    </p>
    </button>
  </div>
  </div>
  
  <div class="input-group mb-3">
    <input [(ngModel)]="filtertext" type="text" class="form-control" placeholder="{{ 'tagaddremove.taghelp' | trans }}" 
    aria-label="Recipient's username" aria-describedby="basic-addon2">
    <div class="input-group-append h-35" (click)="createTag(filtertext)">
      <button  class="btn btn-outline-secondary" type="button"><p class="btn-text">{{ 'tagaddremove.create' | trans }}</p></button>
    </div>
  </div>
  <div class="row pl-2">
    <div *ngFor="let tag of getFilteredAndSearchedTags(); trackBy: trackByTagId" (click)="addTag(tag)" class="col-auto pl-1 pr-1">
      <button class="btn pt-1 pl-2 pr-2 pb-1 mb-2" >
      <p class="btn-text mb-0" appHighlight [searchedWord]="filtertext" [content]="tag.title" [classToApply]="'font-weight-bold'" [setTitle]="'true'" >        
        <span 
        class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
        add
      </span>
    </p>
    </button>
    

  </div>
  </div>

</ng-container>


<div *ngIf="viewmode" class="col-auto"  style="height:20px; margin-top:-4px;">
  <button  *ngFor="let ctag of entitytagList; trackBy: trackByEntityTagId" class="btn p-0 m-0 ml-0">
      <p class="mb-0 ml-2 mr-2 btn-text lh-17 align-middle">{{ctag.title}}</p>
  </button>

</div>
<div class="row">
  <!-- <div class="col-" *ngFor="let ctag of entitytagList">
    <button  class="btn rounded pt-1 ml-2 pl-2 pr-2 pb-1" style="margin-top:-2px;">
      <p class="btn-text mb-0 ">{{ctag.title}}           
        <span (click)="removeTag(ctag)"
        class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
        close
      </span>
    </p>
    </button>
  </div> -->
  <div class="col">
    <div class="dropleft">
      <ng-container *ngIf="smalltype && !viewmode">
        <!-- <a _ngcontent-cwu-c151="" data-toggle="modal" data-target="#assignTags"
        class="cursor-pointer"><span _ngcontent-cwu-c151="" mattooltip="Manage tags" 
        mattooltipposition="left" mattooltipshowdelay="500" 
        class="mat-tooltip-trigger material-icons bg-lightgrey f-20 opacity text-center mr-3 center rounded-circle p-2 text-muted cursor-pointer" 
        ng-reflect-message="Manage tags" ng-reflect-position="left" ng-reflect-show-delay="500" 
        aria-describedby="cdk-describedby-message-2" cdk-describedby-host=""> label 
        </span><p _ngcontent-cwu-c151="" class="mb-0 pt-1 mr-3 text-center f-13">
          </p></a> -->
          <a data-toggle="modal" data-target="#assignTags" matTooltip="{{ 'tagaddremove.enablesort' | trans }}" 
          mattooltipposition="above" mattooltipshowdelay="500">
            <span  
            class=" material-icons m-0 mr-3 rounded-circle btn portal-icon p-1 w-33 h-33" 
             > label </span>
          </a>

      </ng-container>

<ng-container *ngIf="!smalltype && !viewmode && !modalmode">
  <!----
  <a _ngcontent-cwu-c151="" data-toggle="modal" data-target="#assignTags"
  class="cursor-pointer"><span _ngcontent-cwu-c151="" mattooltip="{{ 'tagaddremove.managetags' | trans }}" 
  mattooltipposition="left" mattooltipshowdelay="500" 
  class="mat-tooltip-trigger material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer" 
  ng-reflect-message="Manage tags" ng-reflect-position="left" ng-reflect-show-delay="500" 
  aria-describedby="cdk-describedby-message-2" cdk-describedby-host=""> label 
  </span><p _ngcontent-cwu-c151="" class="mb-0 pt-1 text-center f-13">
    {{ 'tagaddremove.tags' | trans }}</p></a>---->

    <a _ngcontent-cwu-c151="" data-toggle="modal" data-target="#assignTags"
  class="cursor-pointer"><span _ngcontent-cwu-c151="" 
  mattooltipposition="left" mattooltipshowdelay="500" 
  class="mat-tooltip-trigger material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer" 
  ng-reflect-message="Manage tags" ng-reflect-position="left" ng-reflect-show-delay="500" 
  aria-describedby="cdk-describedby-message-2" cdk-describedby-host=""> label 
  </span><!--container--><p _ngcontent-cwu-c151="" class="mb-0 pt-1 text-center f-13">
    {{ 'tagaddremove.tags' | trans }}</p></a>
</ng-container> 


      <!-- <button class="btn-empty border-0" data-toggle="modal" data-target="#assignTags">
        <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
          label
            </span>
    </button> -->
      <!-- <div *ngIf="showTags" style="width:250px;">
        <a class="p-1">  <div class="input-group">
          <input type="text" class="form-control" placeholder="Your tag..." [(ngModel)]="filtertext">
          <div class="input-group-append h-35" (click)="createTag(filtertext)">
            <button class="btn bw" type="button"><p class="btn-text">Create</p></button>
          </div>
        </div></a>
        <a *ngFor="let tag of taglist | appFilter: filtertext" (click)="addTag(tag)" ><p  class="mb-0 " appHighlight [searchedWord]="filtertext" [content]="tag.title"  
          [classToApply]="'font-weight-bold'" [setTitle]="'true'" >          
          </p></a>
      </div> -->
    </div>
  </div>
</div>

<!-- 
<div >
    <button (click)="toggleTags()" class="btn-empty border-0">
        <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
            label
            </span>
    </button>
    <div *ngIf="showTags">
        <button *ngFor="let ctag of entitytagList" class="btn pt-1 pl-2 pr-2 pb-1" (click)="removeTag(ctag)">
            <p class="btn-text mb-0 ">{{ctag.title}}           
              <span (click)="removeTag(ctag)"
              class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
              close
            </span>
          </p>
          </button>
    <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Your tag..." aria-label="Recipient's username" aria-describedby="basic-addon2" [(ngModel)]="filtertext">
        <div class="input-group-append h-35" (click)="createTag(filtertext)">
          <button class="btn btn-outline-secondary" type="button"><p class="btn-text">Create</p></button>
        </div>
      </div>
    <ul class="dropdown">
        <li *ngFor="let tag of taglist | appFilter: filtertext" class="dropdown-item" (click)="addTag(tag)">
            <p  class="mb-0 " appHighlight [searchedWord]="filtertext" [content]="tag.title"  
            [classToApply]="'font-weight-bold'" [setTitle]="'true'" >          
            </p>
        </li>
    </ul>


    </div> -->


<!-- Modal assign tags-->
<div class="modal fade" id="assignTags" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{ 'tagaddremove.assigntags' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ 'tagaddremove.tagmodalhelp' | trans }}</p>
        <div class="row mb-2 pl-1">
          <div class="col- mb-2" *ngFor="let ctag of entitytagList; trackBy: trackByEntityTagId">
          <button  class="btn rounded pt-1 ml-2 pl-2 pr-2 pb-1" style="margin-top:-2px;">
            <p class="btn-text mb-0 ">{{ctag.title}}           
              <span (click)="removeTag(ctag)"
              class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
              close
            </span>
          </p>
          </button>
        </div>
        </div>
        
        <div class="input-group mb-3">
          <input [(ngModel)]="filtertext" type="text" class="form-control" placeholder="{{ 'tagaddremove.taghelp' | trans }}" 
          aria-label="Recipient's username" aria-describedby="basic-addon2">
          <div class="input-group-append h-35" (click)="createTag(filtertext)">
            <button  class="btn btn-outline-secondary" type="button"><p class="btn-text">{{ 'tagaddremove.create' | trans }}</p></button>
          </div>
        </div>
        <div class="row pl-2">
          <div *ngFor="let tag of getFilteredAndSearchedTags(); trackBy: trackByTagId" (click)="addTag(tag)" class="col-auto pl-1 pr-1">
            <button class="btn pt-1 pl-2 pr-2 pb-1 mb-2" >
            <p class="btn-text mb-0" appHighlight [searchedWord]="filtertext" [content]="tag.title" [classToApply]="'font-weight-bold'" [setTitle]="'true'" >        
              <span 
              class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
              add
            </span>
          </p>
          </button>
          
  
        </div>
        </div>
    
    </div>
  </div>
</div>

